import BaseButton from '@/components/BaseButton'
import Pager from '@/components/PagerComponent'
import SuccessDialog from '@/components/SuccessDialog'
import { useToast } from 'vue-toast-notification';

export default {
  components: {
    BaseButton,
    Pager,
    SuccessDialog
  },

  data() {
    return {
      criterias: {
        selectedDistributorRef: null,
        productRef: null,
        requestStatus: null
      },
      allStatus: [
        { value: 'PENDING' },
        { value: 'IN_PROGRESS' },
        { value: 'FAILED'},
        { value: 'CANCELLED'},
        { value: 'DONE' }
      ],
      permissions: JSON.parse(sessionStorage.getItem('user')).permissions,
      comProducts: [],
      requests: [],
      displayedRequests: [],
      distributors: [],
      isDistributorLocked: false,
      responseErr: '',
      error: false,
      validationError: false,
      isProcessing: false,
      requestID: null
    }
  },

  created() {
    if(this.$store.state.requests.invalidData) {
      const $toast = useToast();
      $toast.open({
        message: this.$i18n.t('error.' + this.$store.state.requests.invalidData),
        type:'default',
        position: 'bottom',
        duration: 5000,
        dismissible:true
      });
    }
    this.$store.dispatch('requests/resetInvalidData')
    const user = JSON.parse(sessionStorage.getItem('user'))
    this.getDistributors(user)
    this.getCriterias(user)
    this.getRequests()
  },

  methods: {
    hasPermission (permission) {
      if (!String.prototype.includes) {
        return this.permissions.indexOf(permission, 0) !== -1
      } else {
        return this.permissions.includes(permission)
      }
    },

    updateComProducts () {
      const user = JSON.parse(sessionStorage.getItem('user'))
      this.comProducts = Object.values(user.comProductsMap[this.criterias.selectedDistributorRef])[0]
      this.comProducts.sort((a, b) => a.localeCompare(b))
    },

    async getDistributors (user) {
      this.distributors = Object.keys(user.comProductsMap).sort()
      if (user.ihmDistribRef) {
        this.criterias.selectedDistributorRef = user.ihmDistribRef
        this.isDistributorLocked = true
      }
    },

    async getCriterias (user) {
      if(this.$store.state.requests.criterias && this.$store.state.requests.requests.length > 0) {
        this.criterias = this.$store.state.requests.criterias
      }
      if (user.ihmDistribRef) { // Au cas où le distributeur serait changé
        this.criterias.selectedDistributorRef = user.ihmDistribRef
      }
    },

    async getRequests() {
      this.isProcessing = true
      this.error = false

      await this.$store.dispatch('requests/listReset')
      await this.$store.dispatch('requests/list', {
        distributorRef: this.criterias.selectedDistributorRef,
        productRef: this.criterias.productRef,
        requestStatus: this.criterias.requestStatus
      }).then(
        () => {
          this.isProcessing = false
          this.$store.dispatch('requests/setCriterias', this.criterias)
          if(this.$store.state.requests.requests.length === 0) {
            this.error = true
            this.responseErr = 'NO_REQUESTS_FOUND'
          }
        },
        error => {
          this.isProcessing = false
          this.error = true
          if(error.status === 401) {
            this.responseErr = 'UNAUTHORIZED'
          }
          else {
            this.responseErr = error.data || 'BAD_REQUEST'
          }
        }
      )
    },

    async reset () {
      await this.$store.dispatch('requests/listReset')
      this.$store.dispatch('requests/resetCriterias')
      this.criterias = {
        selectedDistributorRef: null,
        productRef: null,
        requestStatus: null
      }
    },

    showDetails (requestID) {
      this.$store.dispatch('requests/setRequestID', requestID)
      this.$router.push({ name: 'request-details' })
    },

    showEdit (requestID) {
      this.$store.dispatch('requests/setRequestID', requestID)
      this.$router.push({ name: 'request-edit' })
    },

    setRequestID (requestID) {
      this.$store.dispatch('requests/resetRequestID', requestID)
      this.requestID = requestID
    },

    cancel () {
      this.$store.dispatch('requests/cancel', {
        requestID: this.requestID
      }).then(
        () => {
          this.showSuccess(this.$i18n.t('label.request.cancelSuccess'))
          this.getRequests()
        },
        error => {
          this.error = true
          this.responseErr = error.data || 'error.BAD_REQUEST'
        }
      )
    },

    showSuccess (msg) {
      this.$refs.successDialogRef.showSuccess(msg)
    },

  }
}
